import React from "react";
import { Link } from "react-router-dom";
import policyData from "../Datas/policyData";
import "../css/policy.scss";

const EMAIL = "send@isanroute.space";

function renderText(text) {
  const parts = text.split(EMAIL);

  return parts.map((part, index) => (
    <React.Fragment key={`${part}-${index}`}>
      {part}
      {index < parts.length - 1 && <a href={`mailto:${EMAIL}`}>{EMAIL}</a>}
    </React.Fragment>
  ));
}

function PolicyPage({ policyKey }) {
  const policy = policyData[policyKey];

  if (!policy) {
    return null;
  }

  return (
    <main className="policy-page">
      <article className="policy-container">
        <header className="policy-header">
          <p className="policy-kicker">isanroute policies</p>
          <h1>{policy.title}</h1>
          <p className="policy-updated">Last updated: 16 October 2026</p>
          {policy.intro.map((paragraph) => (
            <p key={paragraph}>{renderText(paragraph)}</p>
          ))}
        </header>

        {policy.sections.map((section) => (
          <section className="policy-section" key={section.heading}>
            <h2>{section.heading}</h2>
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph}>{renderText(paragraph)}</p>
            ))}
            {section.bullets && (
              <ul>
                {section.bullets.map((item) => (
                  <li key={item}>{renderText(item)}</li>
                ))}
              </ul>
            )}
            {section.numbered && (
              <ol>
                {section.numbered.map((item) => (
                  <li key={item}>{renderText(item)}</li>
                ))}
              </ol>
            )}
            {section.notice && <p className="policy-notice">{renderText(section.notice)}</p>}
          </section>
        ))}

        <aside className="policy-help" aria-label="Policy help">
          <h2>Need help?</h2>
          <p>
            Email <a href={`mailto:${EMAIL}`}>{EMAIL}</a>. For order-related questions,
            include your order number but never send card details by email.
          </p>
          <Link to="/policies" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            View all policies
          </Link>
        </aside>
      </article>
    </main>
  );
}

export default PolicyPage;
